
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
        this.loaded = this.loaded.bind(this);
    }

    loaded() {
        this.setState({
            loading: false,
        });
    }

    render() {
        let loadingClass = 'card__image--loading';
        if (!this.state.loading) {
            loadingClass = null;
        }

        const overlay = classNames({
            card__image: true
        });

        if (this.props.src) {
            return (
                <div className={overlay}>
                    <img
                        width="280" height="160"
                        className={loadingClass}
                        src={this.props.src}
                        alt={this.props.alt}
                        onLoad={this.loaded}
                    />
                { this.state.loading ? (
                    <div className="card__image__loading" />
                ) : null }
                </div>
            );
        }
        else {
            return (
                <div className={overlay}>
                    <div className="card__image--placeholder"></div>
                </div>
            );
        }
        return null;
    }
}

Image.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string
};
